import LanguageProblemCategory from '@/models/read/LanguageProblemCategory';

class LanguageProblems {
    constructor({ sections }) {
        this._categories = [];
        sections.forEach((section) => {
            Object.values(section.categories).forEach((category) => {
                category.types.forEach((type) => {
                    type.areas.forEach((area) => {
                        let category = new LanguageProblemCategory(area);
                        if (category.problems.length !== 0) {
                            this._categories.push(category);
                        }
                    });
                });
            });
        });
    }

    get categories() {
        return this._categories;
    }
}

export default LanguageProblems;
